export default __webpack_public_path__ + "17245e1845ae230b963d651da67aead3.svg";